// Clinic Configuration for Dentist In Concord
// This file contains all clinic-specific values used across the application

export const CLINIC_CONFIG = {
  // Basic Information
  clinicName: "Dentist In Vernon Hills",
  clinicId: "dentistinvernonhills",
  clinicUrl: "https://www.dentistinvernonhills.com",
  aiAgent: "wss://ws.todaysdentalinsights.com/ai-agents?clinicId=dentistinvernonhills&agentId=efb759b8-e2e4-49db-929e-f67d5c7471d5",
  voiceApiUrl: "https://apig.todaysdentalinsights.com/ai-agents/public/clinic/dentistinvernonhills/voice",

  // Contact Information
  phoneNumber: "8479784077",
  phoneNumberRaw: "+18479784077", // For tel: and sms: links
  email: "DentalCare@dentistinvernonhills.com",

  // Location
  address: "555 E Townline Rd Ste 4, Vernon Hills, IL 60061, United States",
  addressShort: "555 E Townline Rd Ste 4, Vernon Hills, IL 60061",
  city: "Vernon Hills",
  hcity: "Vernon-Hills",
  state: "Illinois",
  stateShortForm: "IL",
  PostalCode: "60061",

  // Map Links
  mapUrl: "https://maps.app.goo.gl/3EJBccxEGW41P8Rh7",

  // Embedded Map
  iframe: 'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d85539.0683377182!2d-87.952841!3d42.238652!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x880f966b6ba3c355%3A0x79a69e9f05683c12!2sDentist%20in%20Vernon%20Hills!5e1!3m2!1sen!2sin!4v1756801787295!5m2!1sen!2sin',
  iframeTitle: "Dentist In Vernon Hills",

  //membership
  membership: "https://member.kleer.com/?slug=VU2G",

  // Sunbit
  sunbitUrl: "https://www.dentistinvernonhills.com/patient-portal",

  // Cherry
  cherryUrl: "https://www.dentistinvernonhills.com/patient-portal",

  // Analytics
  gaMeasurementId: "G-QQZB97R61M",
  clarityProjectId: "prdmxxnpab",

  // Google Ads — direct conversion tracking
  googleAdsId: "AW-11502436222",
  googleAdsConversions: {
    // Primary — used for Smart Bidding optimization
    "phone_call_click": "AW-11502436222/YvJ8CLP6w5QcEP7-5Owq",
    "contact_form_success": "AW-11502436222/8KlZCLKzwoYcEP7-5Owq",
    "call_back_success": "AW-11502436222/izjCCJ62roYcEP7-5Owq",
    "chatbot_phone_click": "AW-11502436222/exWLCLn6w5QcEP7-5Owq",
    "chatbot_voice_call": "AW-11502436222/kTulCPn7w5QcEP7-5Owq",
    "book_appointment_success": "AW-11502436222/HJWrCJeyroYcEP7-5Owq",
    "Confirm-Booking": "AW-11502436222/PSAhCND2w5QcEP7-5Owq",
    "Submit-Payment": "AW-11502436222/nEY3CNP8w5QcEP7-5Owq",
    // Secondary — observation/reporting only
    "sms_click": "AW-11502436222/sfl6CNb2w5QcEP7-5Owq",
    "directions_click": "AW-11502436222/qT7aCNb8w5QcEP7-5Owq",
    "email_click": "AW-11502436222/z_sgCJH8w5QcEP7-5Owq",
    "map_click": "AW-11502436222/d7mXCNz2w5QcEP7-5Owq",
    "social_media_click": "AW-11502436222/RuJtCOL8w5QcEP7-5Owq",
    "financing_click": "AW-11502436222/Sml6CIr-w5QcEP7-5Owq",
    "membership_click": "AW-11502436222/YKzUCOKkzZQcEP7-5Owq",
    "outbound_link_click": "AW-11502436222/UtS6COj8w5QcEP7-5Owq",
    "chat_send": "AW-11502436222/A-2ECKGozZQcEP7-5Owq",
    "chatbot_quick_action": "AW-11502436222/RAsSCKSozZQcEP7-5Owq",
    "chatbot_insurance_upload": "AW-11502436222/Af45COaUuJQcEP7-5Owq",
  } as Record<string, string>,

  // API Configuration
  apiBaseUrl: "https://apig.todaysdentalinsights.com/patientportal/dentistinvernonhills",
  callbackUrl: "https://apig.todaysdentalinsights.com/callback/dentistinvernonhills",
  clinicHoursUrl: "https://apig.todaysdentalinsights.com/clinic-hours/hours/dentistinvernonhills",
  websocketUrl: "wss://ws.todaysdentalinsights.com/chat",
  webAssistantUrl: "https://dentistinvernonhills.web-assistant.tensorlinks.app/",

  // Social Media Links
  social: {
    facebook: "https://www.facebook.com/DentistinVernonHills",
    instagram: "https://www.instagram.com/stories/dentist_vernonhills/",
    twitter: "https://x.com/dentVernonHills",
    linkedin: "https://www.linkedin.com/company/107864973/admin/?lipi=urn%3Ali%3Apage%3Ad_flagship3_feed%3BZHzZHS4UQLaEyel%2BGoze8g%3D%3D",
    youtube: "https://www.youtube.com/@DentistinVernonhills",
  },
  // Review Links (for Patient Reviews page)
  reviewLinks: {
    google: "https://business.google.com/n/15382743729605921508/profile?hl=en-GB&fid=8765868130550955026",
    facebook: "https://www.facebook.com/dentistinvernonhills.official/",
    yelp: "https://www.yelp.com/biz/dentist-in-vernon-hills-vernon-hills",
  },

  // Open Dental Configuration
  defaultProvNum: 199,
  defaultOpNum: 6652,

  // Appointment Types Configuration
  appointmentTypes: [
    {
      value: 'New patient emergency/other',
      label: 'New patient emergency/other',
      duration: 30,
      opNum: 6650,
      AppointmentTypeNum: 5
    },
    {
      value: 'Existing patient emergency/other',
      label: 'Existing patient emergency/other',
      duration: 30,
      opNum: 6652,
      AppointmentTypeNum: 8
    },
    {
      value: 'Existing patient current treatment Plan',
      label: 'Existing patient current treatment Plan',
      duration: 30,
      opNum: 6652,
      AppointmentTypeNum: 3
    },
  ],


  // Twilio Configuration
  twilioPhoneNumber: "12242698612",

  // Helper functions for common patterns
  getTelLink: function () {
    return `tel:${this.phoneNumberRaw}`;
  },

  getSmsLink: function (body?: string) {
    const bodyText = body || "Hello%20";
    return `sms:+${this.twilioPhoneNumber}?body=${bodyText}`;
  },

  getEmailLink: function (subject?: string, body?: string) {
    const params = [];
    if (subject) params.push(`subject=${encodeURIComponent(subject)}`);
    if (body) params.push(`body=${encodeURIComponent(body)}`);
    const queryString = params.length > 0 ? `?${params.join('&')}` : '';
    return `mailto:${this.email}${queryString}`;
  },
};

// Export individual items for convenience
export const {
  clinicName,
  clinicId,
  phoneNumber,
  phoneNumberRaw,
  email,
  address,
  addressShort,
  city,
  state,
  stateShortForm,
  mapUrl,
  iframe,
  iframeTitle,
  clarityProjectId,
  apiBaseUrl,
  callbackUrl,
  clinicHoursUrl,
  websocketUrl,
  social,
  reviewLinks,
  defaultProvNum,
  defaultOpNum,
  appointmentTypes,
} = CLINIC_CONFIG;

export default CLINIC_CONFIG;

